module.exports = __webpack_public_path__ + "img/tessllate.0577ad25.png";